import { ITestAnswer } from "@/shared/components/charts/types/chartTypes";
import { ILocalizedTestElement } from "@/modules/assessments/types/test.interface";

export const getLastAnsweredPageIndex = (questionsList: ILocalizedTestElement[][], testAnswers: ITestAnswer) => {
  if (!questionsList.length || !testAnswers) {
    return -1;
  }

  const answeredElementKeys = new Set(testAnswers.answer.filter((a) => a.answerKey).map((a) => a.elementKey));

  let lastAnsweredPageIndex = -1;
  for (let i = questionsList.length - 1; i >= 0; i--) {
    if (questionsList[i][0]?.testId === testAnswers.testId) {
      const hasAnsweredElement = questionsList[i].some((element) => answeredElementKeys.has(element.config.key));
      if (hasAnsweredElement) {
        lastAnsweredPageIndex = i;
        break;
      }
    }
  }

  return lastAnsweredPageIndex;
};
